import React from 'react';
import './notifications.scss';

import closeIcon from '../../../assets/images/close.svg';
import { MONTHS, joinClasses } from '../../../utils/helpers';

/** @import {NotificationProps} from './NotificationTypes' */

const Notification = (/** @type {NotificationProps} */ { notification, onDismiss }) => {
  const { date, title, body, read } = notification;
  let className = joinClasses("notification", read() ? "notification--read" : "");
  return (
    <div className={className}>
      <button className="notification__close-button" onClick={() => onDismiss(notification)}>
        <img src={closeIcon} />
      </button>
      <div className="notification__date">
        {date.getDate()} {MONTHS[date.getMonth()]} {date.getFullYear()}
      </div>
      <div className="notification__title">
        {title}
      </div>
      <div className="notification__content">
        {body.title && <span><p><b>{body.title}</b></p><br /></span>}
        {body.subTitle && <p>{body.subTitle}</p>}
        {body.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
      </div>
    </div>
  );
};

export default Notification;
